import type * as React from 'react';

export const Container: React.FunctionComponent = ({ children }) => {
  return (
    <div className='flex flex-col items-center w-full bg-white'>{children}</div>
  );
};
